<template>
<div   >
  <van-grid class="barContent" :column-num="4">
        <van-grid-item v-for="(item,index) of list" :key="index" :text="item.title" @click="handleClick(index)" :badge="item.num?item.num:''">
            <template #icon>
                <img class="icon" :src="item.icon"/>
            </template>
        </van-grid-item>
  </van-grid>
</div>
  
</template>

<script>
export default {
    data() {
        return {
            list:[{id:"1",title:"全部订单",icon:require("@/assets/icons/quanbudingdan.png")},
                  {id:"2",title:"待支付",icon:require("@/assets/icons/daifukuan.png"),num:''},
                  {id:"3",title:"已关闭",icon:require("@/assets/icons/yiguanbi.png")},
                  {id:"4",title:"支付成功",icon:require("@/assets/icons/zhifusuccess.png")},
            ],
        };
    },
    methods:{
        handleClick(e){
            this.$router.push({path:"/myOrder/"+e})
        }
    },
}
</script>

<style scoped>
    .barContent{
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 5px 0px rgba(105,10,7,0.07);
        border-radius:10px;
        margin: 1px 5px 5px 5px;
    }
    .barContent /deep/ .van-grid-item__text{
        color: #333;
        font-size:13px ;
    }
    .barContent /deep/ .van-info{
        color: #F34A43; 
        font-size: 11px;
        background-color: #f7f8fa;
        border-color: #F34A43;
        width: 15px;
        height: 15px;
        line-height: 15px;
    }
    .van-grid-item__content{
        background-color: transparent;
    }
    .item{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .icon{
        height: 23px;
        margin-bottom: 12px;
    }
    .barContent /deep/ [class*=van-hairline]::after {
        border: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/myInfoBar.vue